import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import Img from 'gatsby-image';

import ConfirmationColorSwatches from './confirmation-color-swatches';
import Wrapper from '../../elements/wrapper';
import SEO from '../../seo';
import { media, TransitionMixin } from '../../helpers';

import UploadIcon from '../../../images/icons/upload-icon.inline.svg';
import TrashIcon from '../../../images/icons/trash.inline.svg';

const BrandedConfirmationContainer = styled.div`
    > .title-container {
        text-align: center;
        margin-bottom: 50px;

        ${media.large`margin-bottom: 80px;`}
        h4 {
            font-size: 1.1rem;
            font-style: italic;
            color: #000;
        }

        h1 {
            font-size: 3rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 30px;
        }

        p {
            font-size: 1.1rem;
            max-width: 950px;
            margin: 0 auto;
            line-height: 1.5;
        }

        .btn-container {
            padding-top: 30px;
            a {
                max-width: 170px;
                width: 100%;
                padding: 20px 0;
                background-color: #f74d33;
                color: #fff;
                text-decoration: none;
                border: none;
                font-weight: bold;
                border-radius: 4px;
                text-align: center;
                display: inline-block;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
            }
        }

        .progress-bar-container {
            display: flex;
            max-width: 550px;
            margin: 0 auto 40px;
            border-radius: 20px;
            border: 2px solid #000;
            .block {
                height: 20px;
                width: 300px;

                border-left: 2px solid #000;

                &:first-child {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                &:last-child {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                }

                &.filled {
                    background-color: #f74d33;
                }
                &.half {
                    background: linear-gradient(90deg, #f74d33 50%, #fff 50%);
                }
            }
        }
    }

    .branded-order-info {
        .customer-info {
            margin-bottom: 40px;
            ${media.medium`display: flex; max-width: 40vw;`}

            .col {
                flex: 1;
            }
        }
    }
    .footer-nav-wrapper {
        display: flex;
        max-width: 80vw;
        align-items: center;

        .left-container {
            flex: 1;

            a {
                color: #000;
            }
        }
        .right-container {
            flex: 1;
            text-align: right;

            a {
                background-color: #f74c34;
                color: #fff;
                font-weight: bold;
                border-radius: 5px;
                display: inline-block;
                padding: 15px 20px;
                border: 1px solid #f74c34;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                min-width: 185px;
                text-align: center;
                text-decoration: none;
                ${TransitionMixin('.25s')};

                &:hover {
                    background-color: #fff;
                    color: #f74c34;
                }
            }
        }
    }

    .image-color-wrapper {
        margin-bottom: 40px;
        ${media.medium`display: flex; max-width: 80vw;`}
        .images-container {
            flex: 2;
            margin-bottom: 30px;
            ${media.medium`padding-right: 50px; margin-bottom: 0px;`}
            ul {
                padding: 0;
                margin: 0;
                list-style: none;
                display: flex;
                flex-wrap: wrap;

                li {
                    flex: 1 1 100%;
                    ${media.medium`flex: 0 0 50%;`}
                    &.no-files {
                        font-style: italic;
                        background-color: transparent;
                    }

                    position: relative;
                    top: 4px;
                    margin-bottom: 10px;
                    border-radius: 5px;
                    svg {
                        position: relative;
                        top: 4px;
                    }
                    .inner-wrap {
                        padding: 20px;
                        display: flex;
                        align-items: center;
                        background-color: #f2f0eb;
                        max-width: 97%;
                        .icon {
                            margin-right: 10px;
                        }
                        .remove {
                            flex: 1;
                            text-align: right;

                            button {
                                line-height: 1;
                                border: none;
                                background-color: transparent;

                                svg {
                                    path {
                                        fill: #702716;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .colors-container {
            flex: 1;

            .line {
                // Draw an SVG top left to bottom right
                background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 10 10'> <path d='M0 0 L0 10 L10 10' fill='red' /></svg>");
                background-repeat: no-repeat;
                background-position: center center;
                //scale it
                background-size: 100% 100%, auto;
            }
        }
    }

    .styles-wrapper {
        margin-bottom: 40px;
        ${media.medium`max-width: 80vw;`}
        .styles-grid {
            display: flex;
            flex-wrap: wrap;

            ${media.medium`margin: 0 -0.5vw;`}
            .item-container {
                margin-bottom: 20px;
                flex: 0 0 50%;
                ${media.medium`flex: 0 0 33.33%;`}
                ${media.large`flex: 0 0 20%;`}
                ${media.laptop`flex: 0 0 16.66%;`}

                &.selected {
                    .inner-wrap {
                        border-color: #13a6ab;

                        .content-container {
                            background-color: #13a6ab;

                            h4 {
                                color: #fff;
                            }

                            p {
                                color: #fff;
                            }

                            button {
                                color: #fff;
                            }
                        }
                    }
                }
                .inner-wrap {
                    max-width: 90%;
                    margin: 0 auto;
                    border: 1px solid #efefef;
                    border-bottom-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                }

                .content-container {
                    background-color: #e5e5e5;

                    border-bottom-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                    padding: 15px;
                    ${media.laptop`padding: 20px;`}

                    h4 {
                        font-size: 1rem;
                        color: #000;
                        margin: 0 0 5px;
                    }

                    p {
                        margin: 0;
                        font-size: 0.8rem;
                        color: #13a6ab;
                        line-height: 1.2;
                    }

                    button {
                        font-size: 0.8rem;
                        color: #000;
                        background-color: transparent;
                        border: none;
                        text-decoration: underline;
                        padding: 0;

                        &:active,
                        &:focus {
                            outline: 0;
                        }

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }
        }
    }
`;

const BrandedConfirmation = ({
    brandedSettings,
    setBrandedSettings,
    brandedInit,
}) => {
    const colorBoxes = [0, 1, 2, 3, 4];
    useEffect(() => {
        brandedInit();
    }, []);
    return (
        <BrandedConfirmationContainer>
            <SEO title="Confirmation –– Branded" />
            <Wrapper className="title-container">
                <h4>Almost done!</h4>
                <div className="progress-bar-container">
                    <div className="block filled"></div>
                    <div className="block filled"></div>
                    <div className="block filled"></div>
                    <div className="block half"></div>
                </div>
                <h1>Confirm design submission</h1>
                <p>
                    Confirm your submission to see personalized designs in just
                    1-2 business days.
                </p>
                <div className="btn-container">
                    <a href="#">Submit Order</a>
                </div>
            </Wrapper>

            <Wrapper className="branded-order-info">
                <Wrapper className="customer-info">
                    <div className="col">
                        <p>
                            <strong>First Name:</strong>{' '}
                            {brandedSettings.first_name}
                        </p>
                        <p>
                            <strong>Last Name:</strong>{' '}
                            {brandedSettings.last_name}
                        </p>
                        <p>
                            <strong>Email:</strong> {brandedSettings.email}
                        </p>
                        <p>
                            <strong>Phone:</strong> {brandedSettings.phone}
                        </p>
                    </div>
                    <div className="col">
                        <p>
                            <strong>Company:</strong> {brandedSettings.company}
                        </p>
                        <p>
                            <strong>Interested in:</strong>{' '}
                            {brandedSettings.interested_in.map((item) => {
                                return item + ', ';
                            })}
                        </p>
                        <p>
                            <strong>Deadline: </strong>
                            {brandedSettings.deadline}
                        </p>
                    </div>
                </Wrapper>
                <Wrapper className="image-color-wrapper">
                    <div className="images-container">
                        <h4>Uploaded Files</h4>
                        <ul>
                            {brandedSettings.reference_files.map(
                                (file, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="inner-wrap">
                                                <span className="icon">
                                                    <UploadIcon />
                                                </span>
                                                <span className="title">
                                                    {file.title}
                                                </span>
                                                <span className="remove"></span>
                                            </div>
                                        </li>
                                    );
                                }
                            )}
                        </ul>
                    </div>
                    <div className="colors-container">
                        <h4>Colors</h4>
                        <ConfirmationColorSwatches
                            brandedSettings={brandedSettings}
                        />
                    </div>
                </Wrapper>
                <Wrapper className="styles-wrapper">
                    <h4>Styles</h4>
                    <div className="styles-grid">
                        {brandedSettings.product_styles.map((style) => {
                            return (
                                <div className="item-container selected">
                                    <div className="inner-wrap">
                                        <div className="image-container">
                                            {style.image && (
                                                <Img fluid={style.image} />
                                            )}
                                        </div>
                                        <div className="content-container">
                                            <h4>{style.title}</h4>
                                            <p className="category">
                                                {style.category}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Wrapper>
                <Wrapper className="footer-nav-wrapper">
                    <div className="left-container">
                        <div className="link">
                            <Link to="/branded/step-3"> {'<'} Go Back</Link>
                        </div>
                    </div>
                    <div className="right-container">
                        <div className="link">
                            <Link to="/branded/step-2"> Submit Order</Link>
                        </div>
                    </div>
                </Wrapper>
            </Wrapper>
        </BrandedConfirmationContainer>
    );
};

export default BrandedConfirmation;
